import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0c096e4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "ctaLink"
}
const _hoisted_4 = ["href"]

import { computed } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { markdownToHtml } from '../../helpers';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableRouteInfo',
  props: {
    routeInfo: {},
    showMoreInfoLink: { type: Boolean },
    moreInfoLink: {},
    moreInfoLinkText: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const htmlContent = computed(() => markdownToHtml(props.routeInfo));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["text", {loading: _ctx.isLoading}])
      }, [
        (htmlContent.value && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: htmlContent.value
            }, null, 8, _hoisted_2))
          : (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
            : _createCommentVNode("", true)
      ], 2)
    ]),
    (_ctx.showMoreInfoLink && _ctx.moreInfoLinkText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "arrowLink",
                href: _ctx.moreInfoLink
              }, _toDisplayString(_ctx.moreInfoLinkText), 9, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})